export const LARGE_LAPTOP = '1920px';
export const SMALL_LAPTOP = '1366px';
export const LANDSCAPE_TABLET = '1024px';
export const PORTRAIT_TABLET = '768px';
export const LANDSCAPE_MOBILE = '640px';
export const PORTRAIT_MOBILE = '480px';
